/**
 * @typedef {'EMISSIONS_TEST'
 *           |'AXLE_ALIGNMENT'
 *           |'EXHAUST_SOOT_PARTICLE_FILTER'
 *           |'BRAKE_CHECK_AND_REPAIR'
 *           |'ELECTRICS_ELECTRONICS_SERVICE'
 *           |'CHASSIS_AND_SHOCK_ABSORBER_CHECK_AND_REPAIR'
 *           |'TRANSMISSION_CHECK_AND_REPAIR'
 *           |'HU_AU'
 *           |'INSPECTIONS_AND_CHECK_UPS'
 *           |'AIR_CONDITIONING_SERVICE'
 *           |'CAR_BODY_SERVICE'
 *           |'MOPED_REPAIR'
 *           |'MOTORCYCLE_REPAIR'
 *           |'OIL_CHANGE'
 *           |'WHEELS_REPAIR'
 *           |'TIRES_REPAIR'
 *           |'WINDSCREEN_REPAIR_AND_REPLACEMENT'
 *           |'AUXILIARY_HEATING_SERVICE'
 *           |'TUNING'
 *           |'ACCIDENT_REPORT'
 *           |'ACCIDENT_REPAIR'
 *           |'AUTHORIZED_WORKSHOP'} WORKSHOP_SERVICES
 */

/**
 * @const WORKSHOP_SERVICES_NAMES
 * @type {Record<WORKSHOP_SERVICES, WORKSHOP_SERVICES>}
 *
 * @description workshop service name items used from dealer service api
 */
export const WORKSHOP_SERVICES_NAMES = {
  EMISSIONS_TEST: 'EMISSIONS_TEST',
  AXLE_ALIGNMENT: 'AXLE_ALIGNMENT',
  EXHAUST_SOOT_PARTICLE_FILTER: 'EXHAUST_SOOT_PARTICLE_FILTER',
  BRAKE_CHECK_AND_REPAIR: 'BRAKE_CHECK_AND_REPAIR',
  ELECTRICS_ELECTRONICS_SERVICE: 'ELECTRICS_ELECTRONICS_SERVICE',
  CHASSIS_AND_SHOCK_ABSORBER_CHECK_AND_REPAIR:
    'CHASSIS_AND_SHOCK_ABSORBER_CHECK_AND_REPAIR',
  TRANSMISSION_CHECK_AND_REPAIR: 'TRANSMISSION_CHECK_AND_REPAIR',
  HU_AU: 'HU_AU',
  INSPECTIONS_AND_CHECK_UPS: 'INSPECTIONS_AND_CHECK_UPS',
  AIR_CONDITIONING_SERVICE: 'AIR_CONDITIONING_SERVICE',
  CAR_BODY_SERVICE: 'CAR_BODY_SERVICE',
  MOPED_REPAIR: 'MOPED_REPAIR',
  MOTORCYCLE_REPAIR: 'MOTORCYCLE_REPAIR',
  OIL_CHANGE: 'OIL_CHANGE',
  WHEELS_REPAIR: 'WHEELS_REPAIR',
  TIRES_REPAIR: 'TIRES_REPAIR',
  WINDSCREEN_REPAIR_AND_REPLACEMENT: 'WINDSCREEN_REPAIR_AND_REPLACEMENT',
  AUXILIARY_HEATING_SERVICE: 'AUXILIARY_HEATING_SERVICE',
  TUNING: 'TUNING',
  ACCIDENT_REPORT: 'ACCIDENT_REPORT',
  ACCIDENT_REPAIR: 'ACCIDENT_REPAIR',
  AUTHORIZED_WORKSHOP: 'AUTHORIZED_WORKSHOP',
};
